'use strict';

import { vsprintf } from 'sprintf-js';

function resolve(path, obj, separator = '.') {
    const properties = Array.isArray(path) ? path : path.split(separator);
    return properties.reduce((prev, curr) => prev && prev[curr], obj);
}

export function useTranslation() {

    let locale = 'en';
    let resource = {};

    const setResource = async (lang, path) => {
        locale = lang;
        const response = await fetch(path);
        resource = await response.json();
    }

    const t = (key, ...args) => {
        const value = resolve(key, resource);
        if (value === undefined) {
            console.warn(`Translation of '${key}' for locale '${locale}' not found.`)
        }
        return vsprintf(value || '', args);
    }

    return {
        setResource,
        t,
        locale
    }
}
